/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BeneficiaryRecord } from './BeneficiaryRecord';
import type { CategoryRecord } from './CategoryRecord';

/**
 * Class used for OUT_BANK_TRANSFER request payload
 */
export type OperationOutBankTransferRecord = {
    /**
     * The amount of merchant's operation
     */
    amount: number;
    beneficiary: BeneficiaryRecord;
    category?: CategoryRecord;
    /**
     * Currency used in the operation
     */
    currency: OperationOutBankTransferRecord.currency;
    /**
     * Brief description on why this operation was created
     */
    description?: string;
    /**
     * The amount that will be paid in fees
     */
    feeValue: number;
    /**
     * Token gotten after pin validation
     */
    mfaToken?: string;
    /**
     * POS payment option type
     */
    posPaymentOption?: string;
    /**
     * Token gotten after otp validation
     */
    xMfaToken?: string;
};

export namespace OperationOutBankTransferRecord {

    /**
     * Currency used in the operation
     */
    export enum currency {
        GHS = 'GHS',
        NGN = 'NGN',
    }


}
